import AppIconButton from '@nxsys/components/AppIconButton';
import { defaultTheme } from '@nxsys/constants/defaultConfig';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Icons } from '@nxsys/types/icons';
import { DraftPayroll } from '@nxsys/types/models/payroll';
import { Tooltip, Tag } from 'antd';
import { isEmailDraftAllowed } from './draftPayslipEmail';

type Props = {
  record: DraftPayroll;
  onDownload: (id: string) => void;
  onConfirm: (id: string) => void;
  onDelete: (id: string) => void;
  // NX-6289: email the draft payslip before the bank file.
  onSendEmail?: (record: DraftPayroll) => void;
};

const DraftPayrollActionCell: React.FC<Props> = ({
  record,
  onDownload,
  onConfirm,
  onDelete,
  onSendEmail,
}) => {
  const { messages } = useTypedIntl();
  const { selfBillRef } = record;
  // The same states as the payslip's mail icon (Payment Summary).
  const isSentEmailSuccess =
    !selfBillRef?.isSendEmailFailed &&
    !selfBillRef?.errorSendEmailFailed &&
    !!selfBillRef?.isSendEmailSelfBill;
  const isSentEmailFailed =
    selfBillRef?.isSendEmailFailed && selfBillRef?.errorSendEmailFailed;

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        gap: 8,
        alignItems: 'center',
      }}
    >
      <Tooltip title={messages['common.download']}>
        <span
          className="cursor-pointer"
          onClick={() => onDownload(record.selfBillRef?.id)}
        >
          <Icons.IconDownload />
        </span>
      </Tooltip>
      <Tooltip title={messages['common.confirm']}>
        <span className="cursor-pointer" onClick={() => onConfirm(record.id)}>
          <Icons.IconCheck color="#00795B" />
        </span>
      </Tooltip>
      {/* Shown only when the row's company allows emailing draft payslips. */}
      {onSendEmail && selfBillRef && isEmailDraftAllowed(record) && (
        <AppIconButton
          title={
            isSentEmailSuccess
              ? messages['common.emailSentDraftPayslipSuccess']
              : isSentEmailFailed
                ? selfBillRef?.errorSendEmailFailed ||
                  messages['common.emailSentDraftPayslipFailed']
                : messages['common.sendEmailDraftPayslip']
          }
          icon={
            isSentEmailFailed ? (
              <Icons.IconSendEmailFailed />
            ) : (
              <Icons.IconEmail
                color={
                  isSentEmailSuccess
                    ? defaultTheme.theme.palette.green[500]
                    : '#666666'
                }
              />
            )
          }
          onClick={() => onSendEmail(record)}
        />
      )}
      <Tooltip title={messages['common.delete']}>
        <span className="cursor-pointer" onClick={() => onDelete(record.id)}>
          <Icons.IconTrash color="red" />
        </span>
      </Tooltip>
      {record?.isPAL && (
        <span>
          <Tag color="warning" className="ml-1">
            PAL
          </Tag>
        </span>
      )}
    </div>
  );
};

export default DraftPayrollActionCell;
